// extracted by mini-css-extract-plugin
export default {"root":"Input_root__tvWVY","input":"Input_input__X7kpP","disabled":"Input_disabled__um-3E"};